import React, { useEffect, useRef, useState } from 'react';
import styles from './Name.module.scss';
import cx from 'classnames';
import {
  requestsSelector,
  setCurrentRequestId,
  setNextButtonEnabled,
  setRequestData,
  setRequestName,
} from '../../../redux/slicers/requestSlicer';
import { useDispatch, useSelector } from 'react-redux';
import { apiCreateRequest, apiUpdateRequest } from '../../../helpers/api';
import { useUserContext } from '../../../contexts/UserContext';
import { isNameValid } from "../../../helpers/validationHelper";
import { MAX_NAME_LENGTH } from "../../../constants/validationConstants";
import { errorToast } from "../../../helpers/toastHelper";
import { REQUEST_EDIT_MAIN_ROUTE } from '../../../constants/routePathConstants';
import { useParams } from 'react-router';

function Name() {
  const dispatch = useDispatch();
  const { isGuestUser } = useUserContext();
  const _requestSelector = useSelector(requestsSelector);
  const [name, setName] = useState(_requestSelector?.requestName || "");
  const dataRef = useRef(name);
  const _requestSelectorRef = useRef(_requestSelector);
  const search = window.location.search?.split("&")
  const _purchaseID = search?.[0]
  const purchaseId = _purchaseID?.split("purchase_id=")?.at(-1)
  const params = useParams();
  const searchParams = new URLSearchParams(location.search);
  const is_existing_model = searchParams.get('is_existing_model');

  useEffect(() => {
    if (purchaseId)
      {
        dispatch(setRequestData(_requestSelector?.purchasedInfo?.title));
        dispatch(setRequestName(_requestSelector?.purchasedInfo?.title))
        _requestSelectorRef.current = _requestSelector
      }
  }, [_requestSelector?.purchasedInfo?.placeRequest])

  useEffect(() => {
    setName(_requestSelector?.requestName)

    if (_requestSelector?.purchasedInfo?.data?.[0]?.price?.is_existing_model) {
      dispatch(setRequestData({ subPages: [{ id: 2 }] }));
    } 

  }, [_requestSelector?.requestName, _requestSelector?.purchasedInfo?.data])

  const handleChange = (e) => {
    if (isNameValid(e.target.value, false)) {
      if (e.target.value?.length < MAX_NAME_LENGTH) {
        dispatch(setRequestData(e.target.value));
        dispatch(setRequestName(e.target.value));
        setName(e.target.value);
      } else {
        errorToast(`Max ${MAX_NAME_LENGTH} characters title allowed.`)
      }
    }
  };

  const handleKeyPress = async (e) => {
    if (e.keyCode === 13) {
      const nextButton = document.getElementById('__Request_nextButton').childNodes[0];
      nextButton?.click();
    }
  };
  
  useEffect(() => {
    dispatch(setRequestData(''));

    return async () => {
      if (dataRef.current) {
        const formData = new FormData();
        formData.append('name', dataRef.current);

        if (purchaseId)
          {
            formData.append('is_pack', true);
            purchaseId?.replace(/%2C/g, ',')?.split(",")?.forEach(_item => {
              formData.append('packinfo', _item);
            })
            if (is_existing_model === "true") {
              formData.append('request_model_type', 'Existing');
            }
          }

        if(isGuestUser()) {
          formData.append('is_internal_team', true);
        }

        if (_requestSelector.currentRequestId || params?.id)
          await apiUpdateRequest(_requestSelector.currentRequestId || params?.id, formData);
        else {
          dispatch(setNextButtonEnabled(false))
          const response = await apiCreateRequest(formData);
          if (response?.data?.id)
          {
            window.history.pushState(null, '', `${window.location.origin}${REQUEST_EDIT_MAIN_ROUTE}${response?.data?.id}/${_purchaseID ? `${_purchaseID}`:''}`);
            dispatch(setCurrentRequestId(response?.data?.id));

            if (purchaseId)
              dispatch(setNextButtonEnabled(true))

            const _formData = new FormData();
            _formData.append(
              'json_data',
              JSON.stringify({
                ..._requestSelectorRef.current,
                currentRequestId: response?.data?.id,
                isNextButtonEnabled: purchaseId ? true : false,
                requestName:dataRef.current,
                requestPages: _requestSelectorRef.current?.requestPages?.map(_item => {
                  if (_item.id === 1){
                    return {..._item, data: dataRef.current, isCompleted: true} 
                  }
                  return _item
                })
              })
            );
            await apiUpdateRequest(response?.data?.id, _formData);
          }
        }
      }
    };
  }, []);

  useEffect(() => {
    dataRef.current = name;
    if (name) {
      dispatch(setNextButtonEnabled(true));
    } else dispatch(setNextButtonEnabled(false));
  }, [name]);

  return (
    <div
      className={cx(
        'd-flex flex-column justify-content-center align-items-center',
        styles.wrapper
      )}>
      <span className={styles.mainTitle}>Let&apos;s give it a title.</span>
      <input
        type="text"
        placeholder="e.g Corner Ella Sofa"
        className={styles.input}
        onChange={handleChange}
        value={typeof name === 'string' ? name : ""}
        onKeyDown={handleKeyPress}
      />
    </div>
  );
}

export default Name;
